const share = (baseUrl, extra) => {
    window.open(`${baseUrl}${extra}`, '_blank');
};
const twitterShare = (text, url) => {
    share(`http://twitter.com/share`, `?text=${encodeURI(text)}&url=${encodeURI(url).replace('#', '%23')}`);
};
const whatsappShare = (text, url) => {
    share('https://api.whatsapp.com/send', `?text=${encodeURI(text)} - ${encodeURI(url).replace('#', '%23')}`);
};
const facebookShare = (url) => {
    share(`https://www.facebook.com/sharer.php`, `?u=${encodeURI(url).replace('#', '%23')}`);
};
const shareExperiment = (EXPERIMENT_SHARE_TEXT, EXPERIMENT_URL) => (service) => () => {
    switch (service) {
        case 'whatsapp':
            whatsappShare(EXPERIMENT_SHARE_TEXT, EXPERIMENT_URL);
            break;
        case 'twitter':
            twitterShare(EXPERIMENT_SHARE_TEXT, EXPERIMENT_URL);
            break;
        case 'facebook':
            facebookShare(EXPERIMENT_URL);
            break;
        case 'clipboard':
            break;
    }
};
export default {
    shareExperiment,
};
